import { Box, Flex, XIcon, SubstackIcon } from '@blockanalitica/ui';
import {
  default as BALogo
  // @ts-ignore
} from '@/assets/logos/BA-logo-full-white.svg?react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Flex
      flexDirection="row"
      gap="xs"
      alignItems="center"
      justifyContent="center">
      <Flex alignItems="center" gap="xs">
        <Flex
          as="a"
          // @ts-ignore
          href="https://twitter.com/BlockAnalitica"
          color="muted"
          target="_blank"
          rel="noreferrer">
          <XIcon size="0" />
        </Flex>
        <Flex
          as="a"
          // @ts-ignore
          href="https://blockanalitica.substack.com/"
          color="muted"
          target="_blank"
          rel="noreferrer">
          <SubstackIcon size="0" />
        </Flex>
      </Flex>
      <Box color="muted">|</Box>
      <Flex
        as="a"
        // @ts-ignore
        href="https://blockanalitica.com"
        color="muted"
        target="_blank"
        rel="noreferrer">
        <BALogo height={30} />
      </Flex>
      <Box color="muted" fontSize="-2">
        © {currentYear}. All rights reserved.
      </Box>
      <Box color="muted">|</Box>
      <Box
        as="a"
        // @ts-ignore
        href="https://blockanalitica.com/terms-of-service/"
        color="muted"
        target="_blank"
        rel="noreferrer"
        fontSize="-2">
        Terms of Service
      </Box>
    </Flex>
  );
}
